import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="shell">
        <div className="footer-logo">
          Hermeneutics <span>Commons</span>
        </div>
        <p className="text-[0.78rem] text-ink-muted">
          {t('footer.copyright', { year })}
        </p>
      </div>
    </footer>
  );
}
